import Button from '@gds/Button/Button';
import { ChevronLeft } from '@gds/Icons/Paths/ChevronLeft';
import { Typography } from '@gds/Typography/Typography';
import { ShareButton } from '@shared-components/ShareButton/ShareButton';

import { GalleryHeaderProps } from '../Gallery.entity';

import styles from './GalleryHeader.module.css';

const GalleryHeader = ({
  props: { onClick, ctaText, sliderCounter, totalImgs, step },
  locale,
}: GalleryHeaderProps) => {
  return (
    <div className={`${styles.header} ${step === 2 ? styles.slideShowGalleryHeader : ''}`}>
      <Button
        className={styles.backButton}
        leftIcon={<ChevronLeft />}
        onClick={onClick}
        variant="link"
      >
        <Typography variant="button2">{ctaText}</Typography>
      </Button>
      {step === 2 && (
        <Typography variant="body2" Component="div" className={styles.nums}>
          {sliderCounter + 1}/{totalImgs}
        </Typography>
      )}
      <div className={styles.auxBtns}>
        <ShareButton locale={locale} />
      </div>
    </div>
  );
};

export default GalleryHeader;
